import { render } from "./WalletModal.vue?vue&type=template&id=1e9c944e&scoped=true"
import script from "./WalletModal.vue?vue&type=script&lang=js"
export * from "./WalletModal.vue?vue&type=script&lang=js"

import "./WalletModal.vue?vue&type=style&index=0&id=1e9c944e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1e9c944e"

export default script